import React from "react";

import { Grid, makeStyles, Typography, Box } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import rocketAnimation from "../../../../../assets/JSON/rocket.json";
import JsonAnimation from "../../../../../components/base/JsonAnimation";

const useStyles = makeStyles(() => ({
  mainHead: {
    fontSize: 42,
    fontWeight: 800,
    textAlign: "center",
    color: COLORS.darks[0][100],
  },
  heading: {
    fontSize: 30,
    fontWeight: 700,
    textAlign: "center",
    color: COLORS.darks[0][100],
  },
  subhead1: {
    fontSize: 30,
    fontWeight: 700,
    textAlign: "center",
    color: COLORS.darks[0][100],
  },
  subhead2: {
    textAlign: "center",
    fontSize: 18,
    color: COLORS.darks[0][100],
  },
}));

export const Success = () => {
  const classes = useStyles();

  return (
    <Grid xs={12} container direction="column" justifyContent="center" alignItems="center">
      <Box>
        <Typography className={classes.mainHead}>You‘re the best!</Typography>
        <Typography className={classes.heading}>
          This Building is now ready for switching
        </Typography>
      </Box>
      <Box my={6}>
        <JsonAnimation loop={true} animationData={rocketAnimation} height={200} width={200} />
      </Box>
      <Box>
        <Typography className={classes.subhead1}>Almost there! Just a little more to go</Typography>
        <Typography className={classes.subhead2}>
          Click “Next” to complete tenancy and units data{" "}
        </Typography>
      </Box>
    </Grid>
  );
};
